import { createStore } from 'vuex';
import { cloneObject, TLanguage } from '@/shared';
import config from '@/config';
import { ISidebarHeader } from '@/shared/interfaces/sidebar-header-config';
import { modules } from './module-exports';

const store = createStore({
  modules,

  state: {
    isPendoInitialized: false,
    s3Url: config?.s3Url,
    logo: '/rentsync_website/panels/global-site-settings/files/1589909193_rentsync_logo_horizontal2x.png',
    language: 'en',
    loading: false,
    sidebarHeaderData: null as ISidebarHeader | null,
    isExpanded: true,
    isTokenRequestInProgress: false,
    isIFrame: window.self !== window.top,
  },

  getters: {
    getLogo: (state) => `${state.s3Url}${state.logo}`,

    sidebarHeaderData: (state): ISidebarHeader | {} => (
      state.sidebarHeaderData
        ? cloneObject(state.sidebarHeaderData as ISidebarHeader)
        : {}
    ),

    isTokenRequestInProgress: (state) => state.isTokenRequestInProgress,
  },

  mutations: {
    setLoading(state, payload: boolean) {
      state.loading = payload;
    },

    setIsTokenRequestInProgress(state, payload: boolean) {
      state.isTokenRequestInProgress = payload;
    },

    setLanguage(state, payload?: TLanguage) {
      state.language = payload || 'en';
    },

    setSidebarHeaderData(state, payload: ISidebarHeader) {
      state.sidebarHeaderData = payload;
    },

    setPendoInitialized(state, payload: boolean) {
      state.isPendoInitialized = payload;
    },

    expandBlade(state, payload: boolean) {
      state.isExpanded = payload;
    },
  },
});

export type TRootState = typeof store['state'];
export default store;
